<template>
  <div
    v-if="popularityStats && isWithSalesPopularityTag"
    class="rounded-full absolute right-0 top-0 z-[1] mx-24 inline-block w-auto -translate-y-1/2 animate-fade-in px-12 py-8"
    :class="backgroundColor"
  >
    <span
      class="body-2-bold flex flex-row items-center gap-4 self-center"
      :class="textColor"
    >
      <DynamicIcon
        v-if="icon"
        class="shrink-0"
        :class="textColor"
        :icon
        size="small"
      />
      <span class="line-clamp-1">{{ popularityStats.tags[0].text }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { IconName } from '@backmarket/design-system/icons/icons'
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'

import type { PopularityStats } from '~/api/checkout/popularity-stats/types'

const props = defineProps<{
  popularityStats?: PopularityStats
  isOutOfStock: boolean
}>()

const backgroundColor = computed(() => {
  return (
    props.popularityStats?.tags?.[0]?.tokens?.backgroundColor?.replace(
      'color-background',
      'bg',
    ) ?? 'bg-surface-brand-hi'
  )
})

const textColor = computed(() => {
  return (
    props.popularityStats?.tags?.[0].tokens?.textColor?.replace(
      'color-text',
      'text',
    ) ?? 'text-static-brand-mid'
  )
})

const icon = computed(() => {
  return (props.popularityStats?.tags?.[0]?.tokens?.icon as IconName) ?? null
})

const isWithSalesPopularityTag = computed(
  () => !props.isOutOfStock && props.popularityStats?.tags.length,
)
</script>
